/*
React main component
*/
import L from 'leaflet';
// import 'leaflet-draw';
import TopNav from '../component/nav.jsx';
import Footer from '../component/footer.jsx';
import ToTop from '../component/toTop.jsx';
import {
  Map,
  Marker,
  Popup,
  TileLayer,
  Circle,
  Polygon,
  Polyline,
  GeoJSON,
  FeatureGroup,
  LayersControl
} from 'react-leaflet';
import {EditControl} from 'react-leaflet-draw';
import Control from 'react-leaflet-control';
import getMask from '../../../../public/json/wicoMask.js';

// import custom configuration for leaflet and esri-leaflet
import {MyCustomMarker, editableLayers, drawOptions, criticalAreas} from './config.js';

import {featureLayer, dynamicMapLayer} from 'esri-leaflet';
import {service} from 'esri-leaflet-gp';
import * as esri from 'esri-leaflet-geocoder';

var results = new L.LayerGroup();
// ArcGIS Online
var agolProvider = esri.arcgisOnlineProvider({
	label: 'ArcGIS Online World Geocoding Service',
    maxResults: 6
});
var searchControl = esri.geosearch({
	useMapBounds: false,
    providers: [
      agolProvider,
      // serverGeocode,
      // parcelLayer
    ],
    placeholder: 'Search for an address',
    title: 'Address Search',
    // searchBounds: searchBounds,
    zoomToResult: true
});
var revGeocodeService = esri.geocodeService();
// var driveTimes = new L.FeatureGroup();
// // network analist drive time poly
// var gpService = service({url: "https://sampleserver1.arcgisonline.com/ArcGIS/rest/services/Network/ESRI_DriveTime_US/GPServer/CreateDriveTimePolygons", useCors: false});
// var gpTask = gpService.createTask();
// // set drive time parameter for analysis
// gpTask.setParam("Drive_Times", "4 8");
// function driveTimeCallback(error, response, raw) {
//   // document.getElementById('info-pane').innerHTML = 'click on the map to calculate 1 and 2 minute drivetimes';
//   var layer = L.geoJSON(response.Output_Drive_Time_Polygons);
//   // console.log(layer.coordsToLatLng);
//   driveTimes.addLayer(layer);
// }

let selected = null;
const Center = [38.3607, -75.5994];
const zoomLevel = 11;
let polyline;
const subs = ['a', 'b', 'c', 'd'];

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'), iconUrl: require('leaflet/dist/images/marker-icon.png'), shadowUrl: require('leaflet/dist/images/marker-shadow.png')});

export default class MapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.resetView = this.resetView.bind(this);
    this.exportData = this.exportData.bind(this);
    this.handleZoomLevelChange = this.handleZoomLevelChange.bind(this);
    this.state = {
      currentZoomLevel: zoomLevel,
      center: Center
    }
  }

  resetView(e) {
    // add functionality to home button to return map view to entire county
    const leafletMap = this.leafletMap.leafletElement;
    leafletMap.setView(e, 11);
  }

  catchGeoJSON() {
    const leafletMap = this.leafletMap.leafletElement;
    const data = editableLayers.toGeoJSON();
    // Stringify the GeoJson
    const convertedData = 'text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(data));
    // Create export
    document.getElementById('exportData').setAttribute('href', 'data:' + convertedData);
    document.getElementById('exportData').setAttribute('download', 'data.geojson');
  }

  exportData() {
    const leafletMap = this.leafletMap.leafletElement;
    // daisy chaining functions
    this.catchGeoJSON();
  }

  componentDidMount() {
    const leafletMap = this.leafletMap.leafletElement;

    leafletMap.on('zoomend', () => {
      window.console.log('Current zoom level -> ', leafletMap.getZoom());
      const updatedZoomLevel = leafletMap.getZoom();
      this.handleZoomLevelChange(updatedZoomLevel);
    });
    leafletMap.on(L.Draw.Event.CREATED, function (e) {
        var type = e.layerType,
            layer = e.layer;

        if (type === 'marker') {
            layer.bindPopup('A popup!');
        } else if (type === 'circle') {
          var radius = layer.getRadius();

        }
        editableLayers.addLayer(layer);
    });
    searchControl.addTo(leafletMap);
    searchControl.on('results', function(data) {
      results.clearLayers();
      // for (var i = data.results.length - 1; i >= 0; i--) {
      //   results.addLayer(L.marker(data.results[i].latlng));
      // }
      if (data.results.length > 0) {
          // set map view
          leafletMap.setView(data.results[0].latlng, 15);
          // open pop-up for location
          var popup = L.popup({closeOnClick: true}).setLatLng(data.results[0].latlng).setContent(data.results[0].text).openOn(leafletMap);
      }
    });
    leafletMap.on('click', function(e) {
      revGeocodeService.reverse().latlng(e.latlng).run(function(error, result) {
        L.marker(result.latlng).addTo(editableLayers).bindPopup(result.address.Match_addr).openPopup();
      });
    });
    // leafletMap.on('click', function(evt) {
    //   var layer = evt.layer;
    //   // document.getElementById('info-pane').innerHTML = 'working...';
    //   driveTimes.clearLayers();
    //   gpTask.setParam("Input_Location", evt.latlng)
    //   gpTask.run(driveTimeCallback);
    //   driveTimes.addLayer(layer);
    // });
    editableLayers.addTo(leafletMap);
    // driveTimes.addTo(leafletMap);
    results.addTo(leafletMap);
  }

  handleZoomLevelChange(newZoomLevel) {
    this.setState({currentZoomLevel: newZoomLevel});
  }

  // react-leaflet-draw functions exposed
  _onEditPath(e) {
    console.log('Path edited !');
  }

  _onCreate(e) {
    polyline = e.layer;
    // To edit this polyline call : polyline.handler.enable()
    console.log('Path created !');
  }

  _onDeleted(e) {
    console.log('Path deleted !');
  }

  _mounted(drawControl) {
    console.log('Component mounted !');
  }

  _onEditStart() {
    console.log('Edit is starting !');
  }

  _onEditStop() {
    console.log('Edit is stopping !');
  }

  _onDeleteStart() {
    console.log('Delete is starting !');
  }

  _onDeleteStop() {
    console.log('Delete is stopping !');
  }

  render() {
    const position = this.state.center;
    const defaultmaskstyle = {
      'color': "#d1d1d1",
      'weight': 1,
      'opacity': .75,
      'fillOpacity': .5
    };
    var content = (
      <div>
        <TopNav/>
        <Map id='map' ref={m => {
          this.leafletMap = m;
        }} style={{
          height: "100vh"
        }} center={position} zoom={this.state.currentZoomLevel}>
          <TileLayer url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}' attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community' maxZoom={15} minZoom={11}/>
          <TileLayer url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}' attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community' maxZoom={20} minZoom={16}/>
          <LayersControl position='topright'>
            {/* General marker with popup demo */}
            <LayersControl.Overlay name='Marker with popup'>
              <Marker position={position}>
                <Popup>
                  <span>A pretty CSS3 popup.
                    <br/>
                    Easily customizable.</span>
                </Popup>
              </Marker>
            </LayersControl.Overlay>
            {/* Editable layer  */}
            <LayersControl.Overlay name='Leaflet Draw editable Layer' checked>
              <FeatureGroup ref='editableLayers'>
                <EditControl position='bottomleft' onEdited={this._onEditPath} onCreated={this._onCreate} onDeleted={this._onDeleted} onMounted={this._mounted} onEditStart={this._onEditStart} onEditStop={this._onEditStop} onDeleteStart={this._onDeleteStart} onDeleteStop={this._onDeleteStop} draw={drawOptions}/>
              </FeatureGroup>
            </LayersControl.Overlay>
          {/* <LayersControl.Overlay name='4 - 8 Minute Drive Times'>
            <FeatureGroup ref={m => {
              this.driveTimePolys = m;
            }} onEachFeature>

            </FeatureGroup>
          </LayersControl.Overlay> */}
          </LayersControl>

          <GeoJSON ref='geojson' data={getMask()} style={defaultmaskstyle}/>
          <Control position="topright">
            <a id='resetView' title='Reset View' onClick={() => this.resetView([38.3607, -75.5994])}></a>
          </Control>
          <Control position="topright" >
            <a id='exportData' title='Download Drawing' onClick={(editableLayers) => this.exportData(editableLayers)}></a>
          </Control>
        </Map>
        <Footer/>
        <ToTop/>
      </div>
    );
    return content;
  }
};



// WEBPACK FOOTER //
// src/js/view/map/map.jsx